import { render, staticRenderFns } from "./samecityMultiScaninEdit.vue?vue&type=template&id=fb152c16&scoped=true"
import script from "./samecityMultiScaninEdit.vue?vue&type=script&lang=js"
export * from "./samecityMultiScaninEdit.vue?vue&type=script&lang=js"
import style0 from "./samecityMultiScaninEdit.vue?vue&type=style&index=0&id=fb152c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb152c16",
  null
  
)

export default component.exports